import React, { useState } from "react";
import { Modal, Box } from "@mui/material";
import "./PayslipCustomModal.css";
interface ModalProps {
  isModalOpen?: boolean;
  modalWidth?: string;
  modalHeight?: string;
  overflowY?: any;
  overflowX?: any;
}

const PayslipCustomModal: React.FC<React.PropsWithChildren<ModalProps>> = ({
  children,
}) => {
  return (
    <Modal open={true}>
      <Box
        style={{
          padding: "1em",
          position: "absolute",
          borderRadius: "0.25em",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "#FFFFFF 0% 0% no-repeat padding-box",
          boxShadow: "0px 6px 16px #999BA81A",
          width: "35.5em",
          height: "auto",
          overflowY: "auto",
          maxHeight: "90%",
        }}
      >
        <Box
          className="payslip_child"
          style={{
            height: "auto",
          }}
        >
          {children}
        </Box>
      </Box>
    </Modal>
  );
};

export default PayslipCustomModal;
